/* Base add-to-cart for the PDP's own light-DOM form (`form[data-product-form]`
 * in sections/afroyla-product.liquid).
 *
 * Horizon's native `product-form-component` lives partly in Shadow DOM and
 * adds to cart from its own internal fetch, which afroyla-set-picker.js's
 * multi-add intercept cannot reliably pre-empt without an empirical browser
 * session to verify against (phase-06 Risk Assessment §1). Per that same
 * section's stated fallback ("we own the section markup, so this is
 * available"), the PDP buy box is built as our own form instead, and this
 * file is the "theme's own single-add path" afroyla-set-picker.js's catch()
 * block already assumes exists and falls back to via `form.requestSubmit()`.
 *
 * Division of labour on one <form>:
 *   - afroyla-set-picker.js intercepts the ADD button's click in the capture
 *     phase and does its own multi-item /cart/add.js call whenever at least
 *     one set member is ticked (and no set picker is on the page, this file
 *     is the only writer).
 *   - This file owns the SOLO path: it listens for the form's `submit` event
 *     (the click's native default action once nothing intercepted it) and
 *     does a single-item /cart/add.js call. It also re-checks for ticked
 *     members itself, so the two files cooperate correctly regardless of
 *     script load order.
 *
 * Success -> theme:cart:refresh + theme:product:added (the same pair every
 * ported CRO module already listens for). afroyla-theme-events.js bridges
 * theme:cart:refresh to Horizon's real shopify:cart:lines-update, and
 * cart-drawer.js's own auto-open listener (gated on the `auto-open`
 * attribute + the merchant's "auto open cart drawer" setting) takes it from
 * there — this file does NOT also drive the drawer open itself. It used to
 * (a manual click on #afl-cart-toggle), but that button is a TOGGLE
 * (`on:click="#cart-drawer/toggle"`), not an open-only action: firing it
 * unconditionally would close an already-open drawer an instant before the
 * bridge's auto-open reopens it (a flicker), and would force the drawer
 * open even when the merchant has the auto-open setting turned off. Once
 * the bridge existed, the manual toggle became redundant on the success
 * path and wrong on the already-open path, so it was removed (code review
 * finding C1). Failure -> the button re-enables with an inline message;
 * never a dead click. */
(function () {
  'use strict';

  // Theme-editor section re-renders re-execute this script; without a guard
  // the document-level submit listener stacks on every re-render.
  if (window.__aflPdpBuyboxInit) return;
  window.__aflPdpBuyboxInit = true;

  function cartAddUrl() {
    return (window.theme && window.theme.routes && window.theme.routes.cartAdd) || '/cart/add.js';
  }

  function hasTickedSetMembers(form) {
    return form.querySelectorAll('[data-set-member-input]:checked').length > 0;
  }

  function announce(form, text) {
    var note = form.querySelector('[data-atc-note]');
    if (!note) return;
    note.textContent = text || '';
    note.hidden = !text;
  }

  function submitSolo(event) {
    var form = event.target;
    if (!form || !form.matches('form[data-product-form]')) return;
    if (hasTickedSetMembers(form)) return; // afroyla-set-picker.js owns this submit.

    event.preventDefault();

    var idInput = form.querySelector('input[name="id"]');
    var id = idInput ? parseInt(idInput.value, 10) : 0;
    if (!id) return;

    var btn = form.querySelector('[data-add-to-cart]');
    if (btn && btn.disabled) return;
    if (btn) btn.classList.add('is-loading');
    announce(form, '');

    fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (body) { throw new Error(body.description || 'add failed'); });
        return res.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('theme:product:added', { bubbles: true }));
      })
      .catch(function () {
        announce(form, 'That did not go through — please try again.');
      })
      .then(function () {
        if (btn) btn.classList.remove('is-loading');
      });
  }

  document.addEventListener('submit', submitSolo, true);
})();
